import { Type } from '@angular/core';
import { ElementType } from './element-type';
import { Layout } from './layout';
import { PageRequest } from './page-request';

export interface IBaseElement {
  id: string | null;
  elementType: ElementType;
  componentType: Type<any> | null;
  layout: Layout | null;
  content: IBaseElement[] | [];
}

export interface IClickElement {
  pageRequests: PageRequest[] | null;
  confirmAction: any | null; // Use any to avoid circular dependency with Confirm
  modalAction: any | null; // Use any to avoid circular dependency with Modal
}

export class BaseElement implements IBaseElement {
  id: string | null = null;
  elementType: ElementType = ElementType.unknown;
  layout: Layout | null = new Layout();
  componentType: Type<any> | null = null;
  content: IBaseElement[] | [] = [];
}

export class ClickElement implements IBaseElement, IClickElement {
  id: string | null = null;
  elementType: ElementType = ElementType.unknown;
  layout: Layout | null = new Layout();
  pageRequests: PageRequest[] | null = null;
  confirmAction: any | null = null; // Use any to avoid circular dependency with Confirm
  modalAction: any | null = null; // Use any to avoid circular dependency with Modal
  componentType: Type<any> | null = null;
  content: IBaseElement[] | [] = [];
}
